<template>
    <div>
        <o-table :enable-delete="hasPermission(['DELETE api/sandoz/contracts/{id}'])"
                :enable-new="hasPermission(['POST api/sandoz/contracts/{id}'])"
                :enable-edit="hasPermission(['POST api/sandoz/contracts/{id}'])"
                :enable-view="hasPermission(['GET api/sandoz/contracts/{contractId}/view'])"
                :title="$t('sandoz.contracts')"
                ref="tableList"
                url="/api/sandoz/contracts"
                default-sort-by-direction="desc"
                :custom-row-button="true"
                default-sort-by="id"
                :edit-route="dynRoute"
                :enable-page-length="true"
                @page-changed="pageChanged">
            <template slot="filter">
                <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="true">
                    <o-filter-text :title="$t('sandoz.contract_no')" column="contract_no"></o-filter-text>
                    <o-filter-text :title="$t('sandoz.customer_external_id')" column="customer_external_id"></o-filter-text>
                    <o-filter-text :title="$t('sandoz.responsible_sales_person')" column="responsible_sales_person"></o-filter-text>
                    <o-filter-select :items="status" :title="$t('sandoz.status')" column="status"></o-filter-select>
                    <o-filter-select :items="years" :title="$t('sandoz.contract_year')" column="contract_year"></o-filter-select>
                    <o-filter-checkbox :items="previousContract" :title="$t('sandoz.has_previous_contract')" column="no_previous_contract"></o-filter-checkbox>
                    <o-filter-select :items="types" :title="$t('sandoz.contract_type')" column="type"></o-filter-select>
                    <o-filter-text :title="$t('sandoz.company_name')" column="company_name"></o-filter-text>
                    <o-filter-text :title="$t('sandoz.name')" column="name"></o-filter-text>
                    <o-filter-text :title="$t('sandoz.address')" column="address" :placeholder="$t('sandoz.street_zip_city')"></o-filter-text>
                    <o-filter-select :items="buyingGroups" :title="$t('sandoz.buying_group')" column="buying_group" value-field="buying_group_code" text-field="buying_group"></o-filter-select>
                </o-filter>
                <div class="pull-right d-flex">
                  <b-btn class="text-nowrap" v-if="selectedRows.length > 0" variant="primary" v-b-modal.grant-access>
                    {{$t('sandoz.grant_access')}}
                  </b-btn>
                  <b-btn class="ml-2 text-nowrap" v-if="selectedRows.length > 0" variant="primary" @click="confirmUser()">
                    {{$t('sandoz.update_sales_rep')}}
                  </b-btn>
                </div>
            </template>
            <template slot="head">
                <o-table-header :sortable="false">
                  <b-checkbox @change="toggleAllRows"></b-checkbox>
                </o-table-header>
                <o-table-header column="contract_no">{{$t('sandoz.contract_no')}}</o-table-header>
                <o-table-header column="customer_external_id">{{$t('sandoz.customer_external_id')}}</o-table-header>
                <o-table-header :sortable="false">{{$t('sandoz.company_name')}}</o-table-header>
                <o-table-header column="responsible_sales_person">{{$t('sandoz.responsible_sales_person')}}</o-table-header>
                <o-table-header :sortable="false">{{$t('sandoz.new_responsible_sales_person')}}</o-table-header>
                <o-table-header :sortable="false">{{ $t('sandoz.next_approver_role') }}</o-table-header>
                <o-table-header column="status">{{$t('sandoz.status')}}</o-table-header>
            </template>
            <template slot="body" slot-scope="props">
                <td>
                  <b-checkbox :value="props.item.id" v-model="selectedRows"></b-checkbox>
                </td>
                <td>{{ props.item.contract_no }}</td>
                <td>{{ props.item.customer_external_id }}</td>
                <td>{{ props.item.company_name }}</td>
                <td>{{ props.item.responsible_sales_person }}</td>
                <td class="text-center">{{ props.item.new_responsible_sales_user_id ? props.item.new_sales_person.data.name: '' }}
                    <a href="javascript:void(0);" v-if="user && user.is_super_user"
                       @click="openNewSalesPersonModal(props.item)">
                        <fa icon="pencil"></fa>
                    </a>
                </td>
                <td>
                    <template v-if="props.item.is_approved">
                        <template v-if="props.item.next_approver">
                            {{$t('sandoz.approved')}}
                            <a href="javascript:void(0);" @click="openApproverModal(props.item)">
                              <fa icon="info-circle" class="text-success"></fa>
                            </a>
                        </template>
                    </template>
                    <template v-else-if="props.item.status !== 'Cancelled'">
                        {{props.item.next_approver_role}}
                        <a href="javascript:void(0);" v-if="props.item.next_approver_role" @click="openApproverModal(props.item)">
                          <fa icon="info-circle"></fa>
                        </a>
                    </template>
                </td>
                <td>
                  <span v-if="props.item.status == 'Feedback' || props.item.status == 'Rejected'" class="text-danger">
                    {{ $t('sandoz.' + props.item.status.match(/[A-Z][a-z]+/g).join("_").toLowerCase()) }}
                    <fa icon="info-circle" @click.prevent="showFeedback(props.item)"></fa>
                  </span>
                  <span v-else>
                    {{ props.item.status ? $t('sandoz.' + props.item.status.match(/[A-Z][a-z]+/g).join("_").toLowerCase()) : '' }}
                  </span>
                </td>
            </template>
            <template slot="custom-row-button" slot-scope="props">
                <!--
                <b-btn class="mw-52" variant="secondary" v-if="props.item.payment_schema === 'yearly'" @click="downloadInvoice(props.item)">
                    <fa icon="file-invoice-dollar"/>
                </b-btn>
                <b-dropdown variant="secondary" class="invoice-dropdown" v-else-if="props.item.payment_schema === 'semester'">
                    <template #button-content><fa icon="file-invoice-dollar"/></template>
                    <b-dropdown-item-button @click="downloadInvoice(props.item, '_S1')">S1</b-dropdown-item-button>
                    <b-dropdown-item-button @click="downloadInvoice(props.item, '_S2')">S2</b-dropdown-item-button>
                </b-dropdown>
                <b-dropdown variant="secondary" class="invoice-dropdown" v-else-if="props.item.payment_schema === 'quarter'">
                    <template #button-content><fa icon="file-invoice-dollar"/></template>
                    <b-dropdown-item-button @click="downloadInvoice(props.item, '_Q1')">Q1</b-dropdown-item-button>
                    <b-dropdown-item-button @click="downloadInvoice(props.item, '_Q2')">Q2</b-dropdown-item-button>
                    <b-dropdown-item-button @click="downloadInvoice(props.item, '_Q3')">Q3</b-dropdown-item-button>
                    <b-dropdown-item-button @click="downloadInvoice(props.item, '_Q4')">Q4</b-dropdown-item-button>
                </b-dropdown>
                -->
                <b-dropdown v-if="user.is_super_user && props.item.status !== 'Draft'"
                            :popper-opts="{ positionFixed: true }" boundary="window" variant="secondary" size="sm" no-caret>
                  <template #button-content>
                    <fa icon="wand-magic-sparkles"/>
                  </template>
                  <b-dropdown-item href="#" @click.prevent="openResetToDraftModal(props.item.id)">
                    {{ $t('sandoz.reset_to_draft') }}
                  </b-dropdown-item>
                  <b-dropdown-item href="#" @click.prevent="openRestoreApproversModal(props.item.id)">
                    {{ $t('sandoz.restore_approvers') }}
                  </b-dropdown-item>
                  <b-dropdown-item href="#" @click.prevent="openChangeYearModal(props.item.id)">
                    {{ $t('sandoz.change_contract_year') }}
                  </b-dropdown-item>
                </b-dropdown>
                <b-btn variant="secondary" @click="download(props.item)" v-if="canDownload (props.item) && props.item.is_pdf">
                    <fa icon="download"/>
                </b-btn>
                <b-btn variant="secondary" @click="salesforce(props.item)">
                    <fa :icon="['fab', 'salesforce']"/>
                </b-btn>
            </template>
        </o-table>
        <approver-modal ref="approverModal" :contract="contract"/>
        <b-modal id="modal-new-sales-person" ref="newSalesPerson" :ok-title="$t('core.save')"
               :title="$t('sandoz.new_responsible_sales_person')" size="xl" @ok="saveNewSalesPerson">
            <o-value-select v-model="contract.new_responsible_sales_user_id" :label="$t('sandoz.responsible_sales_person')"
                          text-field="name"
                          url="/api/system/users?filter%5Bactive%5D=1%25&sortBy=name"
                          value-field="id"></o-value-select>
        </b-modal>

        <b-modal :title="$t('sandoz.users')" @ok="close" id="grant-access" ref="contractAccessModal" size="lg">
          <o-table url="/api/system/users?filter%5Bactive%5D=1%25" ref="userList" :custom-row-button="true" :enable-new="false" :shadow="false">
                    <template slot="filter">
                      <o-filter v-on:filter-updated="(filters) => $refs.userList.setFilters(filters)">
                        <o-filter-text :title="$t('core.name')" column="name"></o-filter-text>
                        <o-filter-text :title="$t('core.email')" column="email"></o-filter-text>
                      </o-filter>
                    </template>
                    <template slot="head">
                      <o-table-header column="name">{{$t('core.name')}}</o-table-header>
                      <o-table-header column="email">{{$t('core.email')}}</o-table-header>
                    </template>
                    <template slot="body" slot-scope="props">
                      <td>{{ props.item.name }}</td>
                      <td>{{ props.item.email }}</td>
                    </template>
                    <template slot="body-controls" slot-scope="props">
                      <td class="text-right">
                        <div class="btn-group btn-group-sm" role="group" aria-label="edit controls">
                          <b-btn variant="secondary" @click="selectAccessUser(props.item)">
                            <fa icon="sign-in-alt"/>
                          </b-btn>
                        </div>
                      </td>
                    </template>
          </o-table>
        </b-modal>

        <!-- Reset to Draft Modal -->
        <b-modal ref="resetToDraftModal" :title="$t('sandoz.reset_to_draft')" @ok="executeResetToDraft">
          <p>{{ $t('sandoz.reset_confirmation') }}</p>
          <b-form-checkbox v-model="resetApprovalFlow">
            {{ $t('sandoz.reset_approval_flow') }}
          </b-form-checkbox>
        </b-modal>

        <!-- Restore Approvers Modal -->
        <b-modal ref="restoreApproversModal" :title="$t('sandoz.restore_approvers')" :ok-only="true" :ok-title="$t('core.close')" size="xl">
          <p>{{ $t('sandoz.restore_approvers_description') }}</p>
          <b-form-group :label="$t('sandoz.target_status')" label-cols-sm="3" class="mb-3">
            <b-form-select v-model="restoreTargetStatus" :options="restoreStatusOptions"></b-form-select>
          </b-form-group>
          <div v-if="restoreLoading" class="text-center p-3">
            <fa icon="spinner" spin />
          </div>
          <div v-else-if="restoreApproversData.length === 0" class="text-center p-3">
            {{ $t('sandoz.no_removed_approvers') }}
          </div>
          <div v-else>
            <table class="table table-sm table-bordered">
              <thead>
                <tr>
                  <th>{{ $t('sandoz.revision_date') }}</th>
                  <th>{{ $t('core.user') }}</th>
                  <th>{{ $t('sandoz.removed_fields') }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="revision in restoreApproversData" :key="revision.revision_id">
                  <td>{{ revision.created_at | formatDate }}</td>
                  <td>{{ revision.user ? revision.user.name : '-' }}</td>
                  <td>
                    <table class="table table-sm table-borderless mb-0">
                      <tbody>
                        <tr v-for="field in revision.fields" :key="field.key" v-if="field.key !== 'next_approver'">
                          <td class="pl-0 py-0"><strong>{{ field.key }}</strong></td>
                          <td class="py-0">
                            <span v-if="field.key.includes('approval_date')">{{ field.old_value | formatDate }}</span>
                            <span v-else>{{ field.old_value }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td class="text-center">
                    <b-btn variant="primary" size="sm" @click="restoreApprovers(revision.revision_id)">
                      {{ $t('sandoz.restore') }}
                    </b-btn>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-modal>

        <!-- Change Year Modal -->
        <b-modal ref="changeYearModal" :title="$t('sandoz.change_contract_year')" @ok="executeChangeYear">
          <o-value-select :items="years" :label="$t('sandoz.new_year')" v-model="changeYearValue"></o-value-select>
        </b-modal>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import axios from 'axios'
  import ApproverModal from './partials/ApproverModal.vue'
  import { contractYears } from '../../utils/contractYear'
  import { dynamicContractRoute } from '../../utils/dynamicContractRoute'

  export default {
    components: {
      ApproverModal
    },
    data: () => ({
      status: [],
      years: [],
      types: [],
      previousContract: [],
      contract: [],
      selectedRows: [],
      buyingGroups: [],
      resetContractId: null,
      resetApprovalFlow: false,
      restoreContractId: null,
      restoreApproversData: [],
      restoreLoading: false,
      restoreTargetStatus: 'Approved',
      restoreStatusOptions: [
        { value: 'Approved', text: 'Approved' },
        { value: 'Signed', text: 'Signed' }
      ],
      changeYearContractId: null,
      changeYearValue: null
    }),
    created() {
      this.years = contractYears()

      this.status = [
        {value: 'Planned', text: this.$i18n.t('sandoz.planned')},
        {value: 'Draft', text: this.$i18n.t('sandoz.draft')},
        {value: 'Committed', text: this.$i18n.t('sandoz.committed')},
        {value: 'Signed', text: this.$i18n.t('sandoz.signed')},
        {value: 'Lost', text: this.$i18n.t('sandoz.lost')},
        {value: 'Cancelled', text: this.$i18n.t('sandoz.cancelled')},
        {value: 'ZeroInvest', text: this.$i18n.t('sandoz.zero_invest')},
        {value: 'Feedback', text: this.$i18n.t('sandoz.feedback')},
        {value: 'Rejected', text: this.$i18n.t('sandoz.rejected')},
        {value: 'Approved', text: this.$i18n.t('sandoz.approved')},
        {value: 'Invoice Release Pending', text: this.$i18n.t('sandoz.invoice_release_pending')}
      ]
      this.previousContract = [
        {value: 'Yes', text: this.$i18n.t('sandoz.yes') },
        {value: 'No', text: this.$i18n.t('sandoz.no')}
      ]

      this.types = [
        {value: 'APO', text: this.$i18n.t('sandoz.apo')},
        {value: 'APO_ONE', text: this.$i18n.t('sandoz.apo_one')},
        {value: 'CNS', text: this.$i18n.t('sandoz.cns')},
        {value: 'HEIM', text: this.$i18n.t('sandoz.heim')},
        {value: 'IMMUNO', text: this.$i18n.t('sandoz.immuno')},
        {value: 'KAM_APO', text: this.$i18n.t('sandoz.kam_apo')},
        {value: 'KAM_HOSP', text: this.$i18n.t('sandoz.kam_hosp')},
        {value: 'KAM_SD', text: this.$i18n.t('sandoz.kam_sd')},
        {value: 'KAM_WHS', text: this.$i18n.t('sandoz.kam_whs')},
        {value: 'KAM_DIVERSE', text: this.$i18n.t('sandoz.kam_diverse')},
        {value: 'KAM_DIVERSE_HOSP', text: this.$i18n.t('sandoz.kam_diverse_hosp')},
        {value: 'KAM_DIVERSE_INSUR', text: this.$i18n.t('sandoz.kam_diverse_insur')},
        {value: 'ONCO', text: this.$i18n.t('sandoz.onco')},
        {value: 'OTC', text: this.$i18n.t('sandoz.otc')},
        {value: 'SD', text: this.$i18n.t('sandoz.sd')},
        {value: 'SD_GADGET', text: this.$i18n.t('sandoz.sd_gadget')},
        {value: 'CNS_GADGET', text: this.$i18n.t('sandoz.cns_gadget')},
        /*{value: 'ONCO_GADGET', text: this.$i18n.t('sandoz.onco_gadget')},*/
        {value: 'IMMUNO_GADGET', text: this.$i18n.t('sandoz.immuno_gadget')},
        {value: 'KAM_SD_GADGET', text: this.$i18n.t('sandoz.kam_sd_gadget')},
        {value: 'APO_GADGET', text: this.$i18n.t('sandoz.apo_gadget')},
        {value: 'KAM_APO_GADGET', text: this.$i18n.t('sandoz.kam_apo_gadget')},
        {value: 'SD_EDU', text: this.$i18n.t('sandoz.sd_edu')},
        {value: 'CNS_EDU', text: this.$i18n.t('sandoz.cns_edu')},
        {value: 'IMMUNO_EDU', text: this.$i18n.t('sandoz.immuno_edu')},
        {value: 'ONCO_EDU', text: this.$i18n.t('sandoz.onco_edu')},
        {value: 'KAM_SD_EDU', text: this.$i18n.t('sandoz.kam_sd_edu')},
        {value: 'APO_EDU', text: this.$i18n.t('sandoz.apo_edu')},
        {value: 'KAM_APO_EDU', text: this.$i18n.t('sandoz.kam_apo_edu')},
        {value: 'SD_SORTALYS', text: this.$i18n.t('sandoz.sd_sortlays')},
        {value: 'CNS_SORTALYS', text: this.$i18n.t('sandoz.cns_sortlays')},
        {value: 'ONCO_SORTALYS', text: this.$i18n.t('sandoz.onco_sortlays')},
        {value: 'IMMUNO_SORTALYS', text: this.$i18n.t('sandoz.immuno_sortlays')},
        {value: 'KAM_SD_SORTALYS', text: this.$i18n.t('sandoz.kam_sd_sortlays')},
        {value: 'PV', text: this.$i18n.t('sandoz.pv')},
        {value: 'BIOS_APO', text: this.$i18n.t('sandoz.bios_apo')},
        {value: 'HIGHSPEC_GADGET', text: this.$i18n.t('sandoz.highspec_gadget')},
        {value: 'BIOS_KAM_APO', text: this.$i18n.t('sandoz.bios_kam_apo')},
        {value: 'BIOS_KAM_WHS', text: this.$i18n.t('sandoz.bios_kam_whs')},
        {value: 'HIGHSPEC_SORTALYS', text: this.$i18n.t('sandoz.highspec_sortalys')},
        {value: 'APO_OTC', text: this.$i18n.t('sandoz.apo_otc')},
        {value: 'APO_KUKO', text: this.$i18n.t('sandoz.apo_kuko')},
        {value: 'SD_KUKO', text: this.$i18n.t('sandoz.sd_kuko')},
        {value: 'IMMUNO_KUKO', text: this.$i18n.t('sandoz.immuno_kuko')},
        {value: 'HOSP_KUKO', text: this.$i18n.t('sandoz.hosp_kuko')},
        {value: 'CNS_KUKO', text: this.$i18n.t('sandoz.cns_kuko')},
      ]

      // Load buying groups
      axios.get('/api/buying_groups?per_page=9999').then(response => {
        this.buyingGroups = response.data.data.map(bg => ({
          value: bg.buying_group_code,
          text: bg.buying_group,
          buying_group_code: bg.buying_group_code,
          buying_group: bg.buying_group
        }))
      }).catch(error => {
        console.error('Error loading buying groups:', error)
      })
    },
    computed: {
      ...mapGetters({
        user: 'auth/user'
      })
    },
    methods: {
      dynRoute(item) {
        return dynamicContractRoute(this, item)
      },
      hasPermission(item) {
        let result = true
        let permissions = item
        let user = this.user
        if (!user.is_super_user && permissions) {
          permissions.forEach((permission) => {
            if (!user.routePermissions.includes(permission)) {
              result = false
            }
          })
        }
        return result
      },
      showFeedback(item) {
        window.alert(item.approval_feedback)
      },
      hasView() {
        let result = false
        let user = this.user
        if (user.is_super_user) {
          return result;
        } else if(user.routes.length === 1 && user.routes.includes('View Contracts')) {
          result = true
        }

        return result
      },
      canDownload (contract) {
        if (this.hasPermission(['GET api/contracts/{id}/pdf']) && contract) {
          return true
        }
        return false
      },
      download(contract) {
        axios.get('/api/contracts/' + contract.id + '/pdf', { responseType: 'arraybuffer' })
          .then((response) => {
              require('downloadjs')(response.data,
                  contract.customer_external_id + '.pdf', 'application/pdf'
              )
          }).catch((error) => {
              if(error.response.status === 404) {
                  this.$notify({
                      title: this.$i18n.t('core.error'),
                      text: this.$i18n.t('sandoz.file_not_found'),
                      type: 'error'
                  })
              } else {
                  this.$notify({
                    title: this.$i18n.t('core.error_alert_title'),
                    text: this.$i18n.t('core.error_alert_text'),
                    type: 'error'
                  })
              }
        })
      },
      openApproverModal(contract) {
        this.contract = contract
        this.$refs.approverModal.showDialog()
      },
      closeApproverModal() {
        this.contract = null
        this.$refs.approverModal.hideDialog()
      },
      salesforce(contract) {
        window.open('https://sz-scout01.lightning.force.com/lightning/r/Account/' + contract.contact_code + '/view')
      },
      downloadInvoice (contract, payment = '') {
          let param = '1/12'
          if (payment === '_S1') {
              param = '1/6'
          } else if (payment === '_S2') {
              param = '7/12'
          } else if (payment === '_Q1') {
              param = '1/3'
          } else if (payment === '_Q2') {
              param = '4/6'
          } else if (payment === '_Q3') {
              param = '7/9'
          } else if (payment === '_Q4') {
              param = '10/12'
          }

          let name = contract.contract_no
          if(contract.masterAddress && contract.masterAddress.data) {
              let result = contract.masterAddress.data.company_name.substr(0, 3)
              if (result === 'FMH') {
                name = contract.contract_no + '-' + contract.masterAddress.data.name + ' ' + contract.masterAddress.last_name + '-' + contract.masterAddress.city
              } else {
                name = contract.contract_no + '-' + contract.masterAddress.data.company_name + '-' + contract.masterAddress.data.city
              }
          }

          axios.get('/api/sandoz/contracts/' + contract.id + '/invoice/' + param, { responseType: 'arraybuffer' })
              .then((response) => {
                  require('downloadjs')(response.data,
                      name + '' + payment + '.pdf', 'application/pdf'
                  )
              }).catch((error) => {
                  if(error.response.status === 404) {
                    this.$notify({
                      title: this.$i18n.t('core.error'),
                      text: this.$i18n.t('sandoz.file_not_found'),
                      type: 'error'
                    })
                  } else {
                    this.$notify({
                      title: this.$i18n.t('core.error_alert_title'),
                      text: this.$i18n.t('core.error_alert_text'),
                      type: 'error'
                    })
                  }
          })
      },
      openNewSalesPersonModal(contract) {
        this.contract = contract
        this.$refs.newSalesPerson.show()
      },
      closeNewSalesPersonModal() {
        this.contract = null
        this.$refs.newSalesPerson.hide()
      },
      saveNewSalesPerson() {
        axios
          .post(`/api/sandoz/contracts/update_new_sales_person/` + this.contract.id, {
            new_responsible_sales_user_id: this.contract.new_responsible_sales_user_id
          })
          .then((response) => {
            this.$refs.tableList.search()
            this.closeNewSalesPersonModal()
          })
      },
      toggleAllRows(val) {
        this.selectedRows = val ? this.$refs.tableList.data.data.map(e => e.id) : []
      },
      pageChanged(page) {
        this.selectedRows = []
      },
      selectAccessUser(user) {
        axios.post(`/api/sandoz/contracts/bulk_contract_access`, {userID: user.id, contracts: this.selectedRows}).then(response => {
            this.$notify({
              text: this.$i18n.t('sandoz.contact_access_given')
            })
            this.$bvModal.hide('grant-access')
        }).catch(err => {
            this.$notify({
                title: this.$i18n.t('core.save_error'),
                text: this.$i18n.t('core.save_error'),
                type: 'error'
            })
        })
      },
      confirmUser() {
        console.log("heeere")
        this.$bvModal.msgBoxConfirm('Do you really want to set the sales rep according to the value set in the warehouse?', {
          title: 'Update Sales Rep',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'primary',
          okTitle: 'Update',
          cancelTitle: 'Cancel',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if(value) {
            const self = this
            self.updateSalesRep()
          }
        })
        .catch(err => {
          console.log('error', err)
        })
      },
      updateSalesRep() {

        axios.post(`/api/sandoz/contracts/bulk_contract_sales_rep`, {contracts: this.selectedRows}).then(response => {
            this.$notify({
              text: this.$i18n.t('sandoz.updated_sales_rep')
            })
            this.$bvModal.hide('grant-access')
        }).catch(err => {
            this.$notify({
                title: this.$i18n.t('core.save_error'),
                text: this.$i18n.t('core.save_error'),
                type: 'error'
            })
        })
        console.log("in Update")
      },
      openResetToDraftModal(contractId) {
        this.resetContractId = contractId
        this.resetApprovalFlow = false
        this.$refs.resetToDraftModal.show()
      },
      async executeResetToDraft() {
        try {
          await axios.post(`/api/sandoz/contracts/${this.resetContractId}/reset-to-draft`, {
            reset_approval_flow: this.resetApprovalFlow
          })
          this.$refs.tableList.search()
        } catch (error) {
          console.error(error)
        }
      },
      async openRestoreApproversModal(contractId) {
        this.restoreContractId = contractId
        this.restoreApproversData = []
        this.restoreLoading = true
        this.$refs.restoreApproversModal.show()
        try {
          const response = await axios.get(`/api/sandoz/contracts/${contractId}/removed-approvers`)
          this.restoreApproversData = response.data.data
        } catch (error) {
          console.error(error)
        } finally {
          this.restoreLoading = false
        }
      },
      async restoreApprovers(revisionId) {
        try {
          await axios.post(`/api/sandoz/contracts/${this.restoreContractId}/restore-approvers`, {
            revision_id: revisionId,
            target_status: this.restoreTargetStatus
          })
          this.$notify({
            text: this.$i18n.t('sandoz.restored_successfully'),
            type: 'success'
          })
          this.$refs.restoreApproversModal.hide()
          this.$refs.tableList.search()
        } catch (error) {
          console.error(error)
          this.$notify({
            title: this.$i18n.t('core.error'),
            text: this.$i18n.t('core.error_alert_text'),
            type: 'error'
          })
        }
      },
      openChangeYearModal(contractId) {
        this.changeYearContractId = contractId
        this.changeYearValue = null
        this.$refs.changeYearModal.show()
      },
      async executeChangeYear() {
        if (!this.changeYearValue) return

        try {
          await axios.post(`/api/sandoz/contracts/${this.changeYearContractId}/change-year`, {
            year: this.changeYearValue
          })
          this.$notify({
            title: this.$i18n.t('core.saved'),
            text: this.$i18n.t('core.saved_text'),
            type: 'success'
          })
          this.$refs.tableList.search()
        } catch (error) {
          console.error(error)
          this.$notify({
            title: this.$i18n.t('core.error'),
            text: this.$i18n.t(error.response.data.message) || this.$i18n.t('core.error_alert_text'),
            type: 'error'
          })
        }
      }
    }
  }
</script>
